<template>
    <div>
        <div class="card my-3">
            <div class="card-header">
                教师报名审核管理
            </div>
            <div class="card-body" style="min-height: 650px">
                <div v-if="studentData.length===0" class="alert alert-warning">没有教师报名信息</div>
                <div v-else>

                    <div class="card" :class="{'mt-3': index!==0}" v-for="(cls, index) in studentData">
                        <div class="card-header">
                            <div class="row">
                                <div class="col-6">
                                    {{cls.studentName}}
                                </div>
                                <div class="col-6 text-right">
                                    {{cls.studentClassId? '已报名': '未报名'}}
                                </div>
                            </div>
                        </div>
                        <table class="table table-bordered mb-0">
                            <tbody>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">批次信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.batchName }}</div>
                                        <div class="col-auto text-right">
                                            <button class="btn btn-info btn-sm" @click="btnShowProjectBatchInfoDialog_Click(cls.batchId)">
                                                批次基本信息
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">项目信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.projectName }}</div>
                                        <div class="col-auto text-right">
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectInfo_Click(cls.projectId)">项目基本信息
                                            </button>
                                            <button class="btn btn-info btn-sm mr-2" @click="btnShowProjectTeacherCourse_Click(cls.projectId)">
                                                课程安排信息
                                            </button>
                                            <button class="btn btn-info btn-sm" @click="btnShowProjectAssessment_Click(cls.projectId)">项目考核信息
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">班级信息</th>
                                <td class="text-left align-middle" colspan="7">
                                    <div class="row">
                                        <div class="col" style="line-height: 27px">{{ cls.className }}</div>
                                        <div class="col-auto text-right">
                                            <button class="btn btn-info btn-sm" @click="btnShowClassScheduleDialog_Click(cls.classId)">
                                                教学日程信息
                                            </button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 10%">培训基地</th>
                                <td class="text-left align-middle" colspan="5">
                                    <a href="#" @click="btnShowOrganInfo_Click(cls.organId)">{{cls.organName}}</a>
                                </td>
                                <th class="text-center align-middle" style="width: 10%">联系人</th>
                                <td class="text-left align-middle" style="width: 15%">
                                    <a href="#" @click="btnShowClassContactInfoDialog_Click(cls.personId)">{{cls.personName}}</a>
                                </td>
                            </tr>
                            <tr>
                                <th class="text-center align-middle" style="width: 15%">开始日期</th>
                                <td class="text-left align-middle" style="width: 10%">{{cls.startDateString}}</td>
                                <th class="text-center align-middle" style="width: 15%">结束日期</th>
                                <td class="text-left align-middle" style="width: 10%">{{cls.endDateString}}</td>
                                <th class="text-center align-middle" style="width: 15%" colspan="3">所属院校确认</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.collegeConfirmStateName}}</td>
                                <!-- 2025-12-25 经毕老师确认及教育厅沟通结果，去除主管部门确认环节 -->
                                <!-- <th class="text-center align-middle" style="width: 10%">主管部门确认</th>
                                <td class="text-left align-middle" style="width: 15%">{{cls.adminConfirmStateName}}</td> -->
                            </tr>
                            </tbody>
                        </table>
                        <div class="card-footer text-center">
                            <button class="btn btn-success mr-2"
                                    @click="btnCollegeConfig_Click(cls.studentClassId, true, '确定通过参训教师报名审核？',
                                    cls.studentId, cls.studentName)">
                                审核通过
                            </button>
                            <button class="btn btn-danger"
                                    @click="btnCollegeConfig_Click(cls.studentClassId, false, '确定驳回参训教师报名审核？',
                                    cls.studentId, cls.studentName)">
                                审核驳回
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <b-modal v-model="isShowProjectInfoViewDialogOpen"
                 title="项目实施详细信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-info-view :project-id="projectId"></project-info-view>
        </b-modal>
        <b-modal v-model="isShowProjectTeacherCourseViewDialogOpen"
                 title="课程安排详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-teacher-course-view :project-id="projectId"></project-teacher-course-view>
        </b-modal>
        <b-modal v-model="isShowProjectAssessmentViewDialogOpen"
                 title="项目考核详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-assessment-view :project-id="projectId"></project-assessment-view>
        </b-modal>

        <b-modal v-model="isShowProjectBatchInfoDialogOpen"
                 title="项目批次详细信息"
                 ok-title="确定" :ok-only="true" size="xl"
                 :no-close-on-backdrop="true">
            <project-batch-info-view :batch-id="batchId"></project-batch-info-view>
        </b-modal>

        <b-modal v-model="isShowClassContactViewDialogOpen"
                 title="项目考核详细信息" size="lg"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <person-basic-info-view :person-id="personId" :show-detail-info="false"></person-basic-info-view>
            <person-contact-info-view :person-id="personId" class="mt-3"></person-contact-info-view>
        </b-modal>

        <b-modal v-model="isShowClassScheduleInfoDialogOpen"
                 title="班级教学日程安排信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <project-class-schedule-view :class-id="classId"></project-class-schedule-view>
        </b-modal>

        <b-modal v-model="isShowOrganInfoDialogOpen"
                 title="项目培训基地信息" size="xl"
                 ok-title="确定" :ok-only="true"
                 :no-close-on-backdrop="true">
            <organ-info-view :organ-id="organId" :show-warning-text="false"></organ-info-view>
        </b-modal>
    </div>
</template>

<script>
import dictionary from "@/utils/dictionary";
import studyApi from "@/utils/api/study";
import OrganInfoView from "@/components/user/OrganInfoView";
import ProjectInfoView from "@/components/infoView/ProjectInfoView";
import ProjectTeacherCourseView from "@/components/project/project/ProjectTeacherCourseView";
import ProjectAssessmentView from "@/components/project/project/ProjectAssessmentView";
import PersonContactInfoView from "@/components/person/PersonContactInfoView";
import PersonBasicInfoView from "@/components/person/PersonBasicInfoView";
import ProjectBatchInfoView from "@/components/infoView/ProjectBatchInfoView";
import ProjectClassScheduleView from "@/components/project/project/ProjectClassScheduleView";
import dictionaryData from "@/utils/dictionary";
import commonApi from "@/utils/api/common";
export default {
    name: "CollegeStudentSignInManage",
    components: {
        OrganInfoView,
        ProjectInfoView,
        ProjectTeacherCourseView,
        ProjectAssessmentView,
        PersonContactInfoView,
        PersonBasicInfoView,
        ProjectBatchInfoView,
        ProjectClassScheduleView,
    },
    data: function () {
        return {
            collegeId: this.$store.state.userInfo.userId,
            studentSignInConfirmState: dictionary.studentSignInConfirmState,
            studentClassState: dictionary.studentClassState,

            studentData: [],

            batchId: '',
            projectId: '',
            personId: '',
            classId: '',
            organId: '',

            isShowProjectInfoViewDialogOpen: false,
            isShowProjectTeacherCourseViewDialogOpen: false,
            isShowProjectAssessmentViewDialogOpen: false,

            isShowProjectBatchInfoDialogOpen: false,
            isShowClassContactViewDialogOpen: false,

            isShowClassScheduleInfoDialogOpen: false,

            isShowOrganInfoDialogOpen: false,
        };
    },
    mounted() {
        this.getStudentClassDataByCollege();
    },
    methods: {
        getStudentClassDataByCollege() {
            studyApi.studentClass.getStudentClassDataByCollegeId(this.collegeId, dictionary.studentClassState.V1_NON_CONFIRM).then(res => {
                this.studentData = res.data;
            });
        },

        btnCollegeConfig_Click(studenClasstId, confirmState, message, studentId, studentName) {
            if (confirm(message)) {
                this.updateStudentClassState(studenClasstId, dictionary.userType.COLLEGE, confirmState, false, studentId, studentName);
            }
        },

        updateStudentClassState(studentClassId, userType, confirm, checkIn, studentId, studentName) {
            let info = {studentClassId, userType, confirm, checkIn};
            studyApi.studentClass.updateStudentClassStateInfo(info).then(res => {
                this.getStudentClassDataByCollege();

                let msgInfo = {
                    fromUserId: this.$store.state.userInfo.userId,
                    fromUserName: this.$store.state.userInfo.userName,
                    fromUserType: this.$store.state.userType,
                    toUserId: studentId,
                    toUserName: studentName,
                    toUserType: dictionary.userType.STUDENT,
                    messageTitle: '参训报名状态变更',
                    messageContent: '您当前的参训报名状态已变更，请到项目报名信息页面查看'
                };
                commonApi.message.insertMessageInfo(msgInfo).then(res => {
                });
            });
        },

        btnShowProjectInfo_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectInfoViewDialogOpen = true;
        },
        btnShowProjectTeacherCourse_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectTeacherCourseViewDialogOpen = true;
        },
        btnShowProjectAssessment_Click(projectId) {
            this.projectId = projectId;
            this.isShowProjectAssessmentViewDialogOpen = true;
        },

        btnShowProjectBatchInfoDialog_Click(batchId) {
            this.batchId = batchId;
            this.isShowProjectBatchInfoDialogOpen = true;
        },

        btnShowClassContactInfoDialog_Click(personId) {
            this.personId = personId;
            this.isShowClassContactViewDialogOpen = true;
        },
        btnShowClassScheduleDialog_Click(classId) {
            this.classId = classId;
            this.isShowClassScheduleInfoDialogOpen = true;
        },
        btnShowOrganInfo_Click(organId) {
            this.organId = organId;
            this.isShowOrganInfoDialogOpen = true;
        }
    }
}
</script>

<style scoped>

</style>